import moment from 'moment-mini';
import { lsGetItem, lsSetItem } from '@/constants/utils/localstorage';

export function getTooltipNotiKey(noti) {
  return noti?.key || null;
}

export function hasSeenTooltipNoti(noti) {
  const key = getTooltipNotiKey(noti);
  if (!key) return true;
  return !!lsGetItem(key);
}

export function markTooltipNotiSeen(noti) {
  const key = getTooltipNotiKey(noti);
  if (!key) return false;
  return lsSetItem(key, '1');
}

export function isTooltipNotiExpired(noti) {
  const exp = noti?.expiresAt;
  if (!exp) return false;
  try {
    const expiry = moment(exp, ['MM-DD-YYYY', moment.ISO_8601], true);
    if (!expiry.isValid()) return false;
    return moment().isAfter(expiry.endOf('day'));
  } catch (_) {
    return false;
  }
}

export function shouldShowTooltipNoti(noti) {
  return !hasSeenTooltipNoti(noti) && !isTooltipNotiExpired(noti);
}
